<template>
  <div
    v-if="hasErrors"
    :class="computedThemeClass"
    class="error-box">
    <div class="error-box-error"/>
    <div class="error-box-inner">

      <span 
        v-for="(error, index) in generalErrors"
        :key="index"
        class="error-box-text">{{ error }}</span>

      <span class="error-box-text"><slot/></span>

      <slot name="orgSimilarName" />

      <slot name="orgAddress" />

      <b-form-group v-if="possibleDuplicate">
        <b-form-radio-group
          id="orgAlreadyExists"
          v-model="selected"
          :options="options"
          class="error-box-radios"
          plain
          name="orgAlreadyExists"/>
      </b-form-group>

    </div>
  </div>  
</template>

<script>
export default {
  props: {
    possibleDuplicate: {
      type: Boolean,
      required: false,
      default: false
    },
    themeClass: {
      type: String,
      required: false,
      default: 'grey'
    },
    generalErrors: {
      type: Array,
      required: false,
      default: null
    },
    hasErrors: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      selected: true,
      options: [
        {
          text: 'Yes, This is my organization',
          value: true
        },
        {
          text: 'No, This is not my organization',
          value: false
        }
      ]
    }
  },
  computed: {
    computedThemeClass() {
      return this.themeClass + '-error-box'
    }
  }
}
</script>
